import { Scenarios } from '@jfs/network'

const aadhaarLink = {
  default: [
    {
      url: /customer\/linking/,
      method: 'POST',
      response: { status: 'SUCCESS', data: 'XXXXXXXXXXXX' },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /customer\/linking/,
      method: 'POST',
      responseCode: 5000,
      response: { status: 'FAILURE', error: { code: '33607', message: 'Session does not exists.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { aadhaarLink }
